<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>18th G.H.Raisoni Memorial Rapid Rating Crown</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
    </div>
</section>
<section class="section-lg">
    <div class="container">
        <div class="sec-title">
            <h2> <span>18th G.H.Raisoni Memorial Rapid Rating Crown, Shaunak Badole wins clinches Blitz Rating
                    Title</span>
            </h2>
        </div>
        <p>Nagpur’s Suhan Deshpande wins 18th G.H.Raisoni Memorial Rapid Rating Crown, Shaunak Badole wins clinches
            Blitz Rating Title </p>
        <p>Suhan Deshpande from Nagpur with a score of 8 ½ points out of total 9 annexed the title of 18th G H Raisoni
            Memorial International FIDE (Rapid) Rating Chess Tournament which concluded on 15th June 2025 at G.H.Raisoni
            Institute of Information and Technology, Shraddha Park, Wadi Hingna Link Road, Near MIDC Police Station,
            Nagpur. The event was organised by G.H.Raisoni Sports and Cultural Foundation jointly with Kalpana Prakash
            Welfare Foundation and is recognised by the Chess Association Nagpur, Maharashtra Chess Association, All
            India Chess Federation and FIDE.
        </p>
        <p>Shaunak Badole of Nagpur with 9 points out of Nine rounds won the 18th G H Raisoni Memorial International
            FIDE (Blitz) Rating Chess Tournament which was also held on 15th June 2025. FM Siddhant Gawai, Vivaan
            Saraogi and Saksham Wadhwa scored 8 points and were placed 2nd to 4th based on their tie break points.</p>
        <p>The total prize fund was ₹30,000 in cash, along with 74 trophies and medals distributed among the top
            performers. All participants were also awarded participation certificates based on their performance.</p>
        <p>In the Rapid Rating event, Suhan with seven consecutive wins in last seven rounds emerged winner with 8 ½
            points, a half point more than the runners-up. After penultimate round, Suhan, FM Kumar Gaurav of Bihar and
            another Nagpur youngster Dishank Bajaj led the table with 7 ½ points each. However, in a dramatic turn of
            events, Suhan toppled FM Kumar Gaurav on the top table whereas Dishank Bajaj went down to the top seed IM
            Kaustav Kundu. Another Nagpur youngster FM Vaibhav Raut scored over Nilay Kulkarni to reach 8 points and bag
            the second position. Ayush Ramtete of Nagpur toppled Aarit Thakur to reach 8 points to finish third thereby
            completing the top three positions to Nagpur players. Top seed IM Kaustav Kundu also scored 8 points but was
            ranked 4th after applying tie breaks.</p>
        <p>Prizes were distributed at the hands of Chief Guest Noted Social Worker and Senior BJP Leader Shri Jaiprakash
            Gupta, Guests of Honour Shri Shekhar Suryawanshi, Superintendent, CGST and Athletics Coach & Organiser, CA
            Saket Bagadia, Ex-Chairman ICAI Nagpur and Shri Rahul Naidu, Executive Member Chess Association Nagpur & MD
            Prathamam Manpower Pvt Ltd. Shri Bhushan Shriwas, Secretary, Kalpana Prakash Welfare Foundation and Chess
            Association Nagpur</p>
    </div>
</section>
